import { apiFetch } from '../api';

/**
 * Obtiene todos los usuarios del sistema (requiere rol ADMINISTRACIÓN o GESTIONUSERS)
 * @returns {Promise<Array>}
 */
export async function getUsers() {
  const res = await apiFetch('/users');
  if (!res.ok) throw new Error("No se pudieron obtener los usuarios");
  return await res.json();
}

/**
 * Crea un nuevo usuario en la plataforma.
 * Requiere derechos de ADMINISTRADOR o GESTIONUSERS.
 * @param {Object} userData - Datos del usuario a crear
 * @returns {Promise<Object>}
 */
export async function createUser(userData) {
  const res = await apiFetch('/user', {
    method: 'POST',
    body: JSON.stringify(userData)
  });

  const data = await res.json();
  if (!res.ok || data.status !== 'OK') {
    throw new Error("No se pudo crear el usuario");
  }

  return data;
}

/**
 * Actualiza un usuario existente (puede incluir email, contraseña o grupos)
 * @param {Object} userData - Objeto con los datos a actualizar (ver doc de PUT /user)
 * @returns {Promise<Object>}
 */
export async function updateUser(userData) {
  const res = await apiFetch('/user', {
    method: 'PUT',
    body: JSON.stringify(userData)
  });

  const data = await res.json();
  if (!res.ok || data.status !== 'OK') {
    throw new Error("No se pudo actualizar el usuario");
  }

  return data;
}

/**
 * Consulta los datos completos de un usuario por su nombre de usuario (username)
 * Requiere tener rol ADMINISTRACIÓN, GESTIONUSERS o ser el propio usuario
 * 
 * @param {string} username - Nombre del usuario a consultar
 * @returns {Promise<Object>} - Objeto con datos completos del usuario (COD_ID, EMAIL, GRUPOS, etc.)
 */
export async function getUserByUsername(username) {
  const res = await apiFetch(`/user?username=${username}`);
  if (!res.ok) throw new Error("No se pudo obtener el usuario");
  const data = await res.json();
  return Array.isArray(data) ? data[0] : data;
}

/**
 * Obtiene los usuarios asociados a un cliente concreto.
 * @param {string} codCliente - Identificador del cliente.
 * @returns {Promise<Array>}
 */
export async function getUsersByClient(codCliente) {
  if (!codCliente) return [];

  const res = await apiFetch(`/users?ID=${codCliente}`);
  if (!res.ok) throw new Error("No se pudieron obtener los usuarios del cliente");
  return await res.json();
}